import React, { useContext } from 'react';
import AppContext from 'context/Context';
import SidebarCustomerHeader from './SidebarCustomerHeader';
import SidebarTicketDetails from './SidebarTicketDetails';
import SidebarCustomerLicenses from './SidebarCustomerLicenses';
import SidebarTicketHistory from './SidebarTicketHistory';

const TicketCustomerSidebar = ({
  ticket,
  isLoadingDetail = false,
  onTicketUpdated,
  participants = [],
  isLoadingParticipants = false,
  onReloadParticipants,
  historyRefreshKey = 0
}) => {
  const { config: { isDark } = {} } = useContext(AppContext);

  return (
    <div
      className="p-3 d-flex flex-column gap-3 h-100 border-start"
      style={{
        width: '320px',
        minWidth: '300px',
        backgroundColor: isDark ? '#121e2d' : '#ffffff',
        borderColor: isDark ? '#233142' : '#dee2e6',
        overflowY: 'auto',
        height: '100%',
        maxHeight: '100%'
      }}
    >
      {/* 1. Header / Perfil del cliente */}
      <SidebarCustomerHeader ticket={ticket} onTicketUpdated={onTicketUpdated} />

      {/* 2. Nivel de soporte y detalles del ticket actual */}
      <SidebarTicketDetails
        ticket={ticket}
        isLoading={isLoadingDetail}
        onTicketUpdated={onTicketUpdated}
        participants={participants}
        isLoadingParticipants={isLoadingParticipants}
        onReloadParticipants={onReloadParticipants}
      />

      {/* 3. Licencias y pólizas del cliente */}
      <SidebarCustomerLicenses idClienteAkasia={ticket.idClienteAkasia} />

      {/* 4. Historial de tickets y movimientos */}
      <SidebarTicketHistory
        idClienteAkasia={ticket.idClienteAkasia}
        currentTicketId={ticket.id}
        ticketState={ticket.iEstadoTicket}
        ticketLevel={ticket.idCatNivelSoporte}
        historyRefreshKey={historyRefreshKey}
      />
    </div>
  );
};

export default TicketCustomerSidebar;
